
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";

import { Head } from "@/components/Head";
import { ContentSection } from "@/sections/ContentSection";

const Privacy = () => {
  return (
    <>
      <Head
        pageNamespace="page/privacy"
        ogImage="/images/privacy-og-image.jpg"
      />
      <ContentSection title="Privacy">
        <p>
          This privacy policy governs your use of the software application
          Magicul (“Application”). The Application enables users to convert and
          share design files of any kind.
        </p>
        <h2>
          What information does the Application obtain and how is it used?
        </h2>
        <p>
          Magicul processes design files that are uploaded to our website in
          order to convert them. All user specific data is stored fully
          encrypted and is solely accessible to us and not shared with any 3rd
          party. Entering any kind of meta data is optional and thus not
          mandatory. By default data uploaded to our system is stored for 2
          years. Users can request their data to be deleted by submitting a
          support ticket at any given time.
        </p>
        <h2>User Provided Information</h2>
        <p>
          The Application obtains the information you provide when you upload a
          file to our service. Registration with us is optional. However, please
          keep in mind that you may not be able to use some of the features
          offered by the Application unless you register with us.
        </p>
        <p>
          When you register with us and use the Application, you generally
          provide (a) your name, email address, age, user name, password and
          other registration information; (b) transaction-related information,
          such as when you make purchases, respond to any offers, or download or
          use applications from us; (c) information you provide us when you
          contact us for help; (d) payment information for purchase and use of
          the Application, and; (e) information you enter into our system when
          using the Application, such as contact information and project
          management information.
        </p>
        <p>
          We may also use the information you provided us to contact you from
          time to time to provide you with important information, required
          notices and marketing promotions.
        </p>
        <h2>Automatically Collected Information</h2>
        <p>
          In addition, the Application may collect certain information
          automatically, including, but not limited to, the type of device you
          use, your operating system, the type of Internet browser you use, and
          information about the way you use the Application. These details are
          stored anonymously and according to the GDPR.
        </p>
        <p>
          In case you use the Facebook or Google signup functionality we might
          also collect information like your registered email address and login
          information.
        </p>
        <p>
          We may disclose User Provided and Automatically Collected Information:
          <br />
          as required by law, such as to comply with a subpoena, or similar
          legal process;
          <br />
          when we believe in good faith that disclosure is necessary to protect
          our rights, protect your safety or the safety of others, investigate
          fraud, or respond to a government request;
          <br />
          with our trusted service providers who work on our behalf, do not have
          an independent use of the information we disclose to them, and have
          agreed to adhere to the rules set forth in this privacy statement.
          <br />
          If Magicul is involved in a merger, acquisition, or sale of all all or
          a portion of its assets, you will be notified via email prominent
          notice on our Web site of any change in ownership or uses of this
          information, as well as any choices you may have regarding this
          information.
        </p>
        <h2>What are my opt-out rights?</h2>
        <p>You can request to opt-out via email, at privacy@magicul.io</p>
        <h1>Data Retention Policy, Managing Your Information</h1>
        <p>
          We will retain User Provided data for as long as you use the
          Application and for a reasonable time thereafter. We will retain
          Automatically Collected information for up to 24 months and thereafter
          may store it in aggregate. If you’d like us to delete User Provided
          Data that you have provided via the Application, please contact us at
          privacy@magicul.io and we will respond in a reasonable time. Please
          note that some or all of the User Provided Data may be required in
          order for the Application to function properly.
        </p>
        <h2>Children</h2>
        <p>
          We do not use the Application to knowingly solicit data from or market
          to children under the age of 13. If a parent or guardian becomes aware
          that his or her child has provided us with information without their
          consent, he or she should contact us at privacy@magicul.io. We will
          delete such information from our files within a reasonable time.
        </p>
        <h1>Security</h1>
        <p>
          We are concerned about safeguarding the confidentiality of your
          information. We provide physical, electronic, and procedural
          safeguards to protect information we process and maintain. For
          example, we limit access to this information to authorized employees
          and contractors who need to know that information in order to operate,
          develop or improve our Application. Please be aware that, although we
          endeavor provide reasonable security for information we process and
          maintain, no security system can prevent all potential security
          breaches.
        </p>
        <h2>Changes</h2>
        <p>
          This Privacy Policy may be updated from time to time for any reason.
          We will notify you of any changes to our Privacy Policy by posting the
          new Privacy Policy here and informing you via email or text message.
          You are advised to consult this Privacy Policy regularly for any
          changes, as continued use is deemed approval of all changes. You can
          check the history of this policy by clicking here.
        </p>
        <h2>Your Consent</h2>
        <p>
          By using the Application, you are consenting to our processing of your
          information as set forth in this Privacy Policy now and as amended by
          us. “Processing,” means using cookies on a computer/hand held device
          or using or touching information in any way, including, but not
          limited to, collecting, storing, deleting, using, combining and
          disclosing information, all of which activities will take place in the
          United States. If you reside outside the United States your
          information will be transferred, processed and stored there under
          United States privacy standards.
        </p>
        <h2>Contact us</h2>
        <p>
          If you have any questions regarding privacy while using the
          Application, or have questions about our practices, please contact us
          via email at privacy@magicul.io.
        </p>
      </ContentSection>
    </>
  );
};

export default Privacy;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/privacy',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  